module.exports = __webpack_public_path__ + "static/img/manual.7fea151.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/manual.png
// module id = BZ3E
// module chunks = 23